/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var CheckmarkInGreyCircleIcon = createIcon("CheckmarkInGreyCircleIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "12",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.625 6.375-7.546 10.779a1.1 1.1 0 01-1.785.03l-1.919-2.56",
    stroke: "#171717",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}, {});